import React from 'react';

interface HeroImageProps {
  src: string;
  alt: string;
  priority?: boolean;
}

function HeroImage({ src, alt, priority = false }: HeroImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className="w-full h-full object-cover"
    />
  );
}

export default HeroImage;